import styled from "@emotion/styled";
import { Notifications } from "@mui/icons-material";
import { Badge, IconButton, List, ListItem, ListItemText, Popover } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const StyledIconButton = styled(IconButton)`
  @apply text-blue-500;
`;

const NotificationBell = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const notifications = useSelector((state) => state?.notifications?.messages) || [];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <StyledIconButton color="inherit" onClick={handleClick}>
        <Badge badgeContent={notifications.length} color="error">
          <Notifications />
        </Badge>
      </StyledIconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List>
          {
            notifications?.length > 0 ? notifications.map((notification, index) => (
              <ListItem key={`${index}-${notification}`}>
                <ListItemText primary={notification} />
              </ListItem>
            )
            )
              :
              <ListItem key={`empty-notification-message`}>
                <ListItemText primary="No notifications" />
              </ListItem>
          }
        </List>
      </Popover>
    </div>
  );
};

export default NotificationBell;
